export const getManagerTenantScorecard = ({
  targetUser = null,
  reviews = [],
  properties = [],
}) => {
  if (!targetUser?.uid) {
    return {
      score: 0,
      label: "No data",
      latePaymentMentions: 0,
      ruleViolationMentions: 0,
      communicationMentions: 0,
      approvedReviewCount: 0,
      managedPropertyCount: 0,
    };
  }

  const approvedTenantReviews = reviews.filter(
    (item) => item?.targetUserId === targetUser.uid && item?.status === "approved"
  );

  const latePaymentMentions = approvedTenantReviews.filter((item) => {
    const categoryValue = Number(item?.categoryRatings?.paysOnTime || 0);
    const textValue = String(item?.text || "").toLowerCase();
    return (
      (categoryValue > 0 && categoryValue <= 2) ||
      textValue.includes("late payment") ||
      textValue.includes("late rent")
    );
  }).length;

  const ruleViolationMentions = approvedTenantReviews.filter((item) => {
    const categoryValue = Number(item?.categoryRatings?.followsRules || 0);
    const textValue = String(item?.text || "").toLowerCase();
    return (
      (categoryValue > 0 && categoryValue <= 2) ||
      textValue.includes("violation") ||
      textValue.includes("lease") ||
      textValue.includes("rules")
    );
  }).length;

  const communicationMentions = approvedTenantReviews.filter((item) => {
    const categoryValue = Number(item?.categoryRatings?.communication || 0);
    return categoryValue > 0 && categoryValue <= 2;
  }).length;

  const averageRating = approvedTenantReviews.length
    ? approvedTenantReviews.reduce((sum, item) => sum + Number(item?.rating || 0), 0) /
      approvedTenantReviews.length
    : 0;

  const managedPropertyCount = properties.filter((item) => {
    const linkedIds = [
      item?.ownerId,
      item?.claimedByUserId,
      item?.claimRequestedByUserId,
      item?.managerUserId,
      item?.communityAddedByUserId,
    ];
    return linkedIds.includes(targetUser.uid);
  }).length;

  let score = 100;
  score -= latePaymentMentions * 18;
  score -= ruleViolationMentions * 15;
  score -= communicationMentions * 10;
  score -= approvedTenantReviews.length ? Math.max(0, (5 - averageRating) * 8) : 8;
  score = Math.max(0, Math.min(100, Math.round(score)));

  let label = "Low Risk";
  if (score < 80) label = "Watch";
  if (score < 60) label = "Moderate Risk";
  if (score < 40) label = "High Risk";

  return {
    score,
    label,
    latePaymentMentions,
    ruleViolationMentions,
    communicationMentions,
    approvedReviewCount: approvedTenantReviews.length,
    managedPropertyCount,
  };
};